// extracted by mini-css-extract-plugin
module.exports = {"back":"Sector-module--back--3Z4Bn","SectorMenu":"Sector-module--SectorMenu--3kJm_"};